import { colors } from '@styles/theme'

export default {
  mapStyle: [
    {
      elementType: 'labels.text',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ visibility: 'simplified' }, { color: colors['red-20'] }]
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text',
      stylers: [{ visibility: 'simplified' }, { color: colors.darkRed }]
    },
    {
      featureType: 'administrative',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ visibility: 'simplified' }, { color: colors['red-20'] }]
    },
    {
      featureType: 'landscape',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ visibility: 'simplified' }, { color: colors['red-20'] }, { lightness: -8 }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{ visibility: 'on' }, { color: colors['red-20'] }, { lightness: -4 }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: colors['red-40'] }, { visibility: 'on' }, { lightness: 10 }]
    },
    {
      featureType: 'landscape',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {},
    {
      featureType: 'road.highway',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [{ visibility: 'on' }, { color: colors['red-20'] }, { lightness: -4 }]
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [{ visibility: 'on' }, { color: colors['red-40'] }, { lightness: 10 }]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [{ visibility: 'simplified' }, { color: colors['red-20'] }, { lightness: 20 }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ visibility: 'on' }, { color: colors['red-50'] }, { lightness: 30 }]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ visibility: 'simplified' }, { color: colors['red-40'] }, { lightness: 42 }]
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }]
    }
  ]
}
